import request from '@/utils/request'

/**
 * gm分页
 */
export const getGmPage = (params) => {
  return request({
    url: 'tools/v1/gm/page',
    params
  })
}

/**
 * gm添加
 */
export const saveGm = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/gm/save',
    data
  })
}

/**
 * gm编辑
 */
export const updateGm = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/gm/update',
    data
  })
}

/**
 * gm删除
 */
export const delGm = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/gm/delete',
    data
  })
}
